<template>
  <div class="invoice-room">
    <div class="picture" :style="`background-image: url(${roomPicture})`"></div>
    <div class="room-info">
      <div class="name">{{roomName}}</div>
      <div class="dates">{{$t('profile.invoice.room.dates', from, to)}}</div>
    </div>
    <div class="details">
      <div class="extras">
        <template v-if="extraCount > 1">
          {{$t('profile.invoice.room.extras', extraCount)}}
        </template>
        <template v-else>
          {{$t('profile.invoice.room.extra', extraCount)}}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: "invoice-room",
  props: {
    room: {
      type: Object,
      required: true
    }
  },
  computed: {
    from() {
      return moment(this.room.start.slice(0, 10)).format('ddd DD MMM')
    },
    to() {
      return moment(this.room.end.slice(0, 10)).format('ddd DD MMM')
    },
    roomPicture() {
      return this.room.room.main_picture.absolute_path + '?w=80&h=80&crop-to-fit'
    },
    roomName() {
      return this.room.room.text.short_name
    },
    extraCount() {
      return this.room.extras.reduce((prev, curr) => {
        return prev + curr.dates.reduce((p, c) => {
          return p + c.number;
        }, 0)
      }, 0);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/client/part/order-history/invoice-room.vue